import * as Yup from 'yup';

const validationSchema = (t, countryCode: string) => {
  const schemaFields = {
    countryCode: Yup.string().required(
      t('building.requiredFieldValidation', {
        field: t('building.countryCode'),
      }),
    ),
    displayAddress: Yup.string().required(t('building.displayAddressValidation')),
    latitude: Yup.string().required(
      t('building.requiredFieldValidation', {
        field: t('building.latitude'),
      }),
    ),
    longitude: Yup.string().required(
      t('building.requiredFieldValidation', {
        field: t('building.longitude'),
      }),
    ),
    locality: Yup.string().required(
      t('building.requiredFieldValidation', {
        field: t('building.city'),
      }),
    ),
    numberOfFloors: Yup.number().min(1, t('building.floorsMinimum')),
    metadata: Yup.object().shape({
      entranceCount: Yup.number().min(0, t('building.amenities.minZero')),
      passengerElevatorCount: Yup.number().min(0, t('building.amenities.minZero')),
      serviceElevatorCount: Yup.number().min(0, t('building.amenities.minZero')),
    }),
    postalCode: Yup.string().required(
      t('building.requiredFieldValidation', {
        field: t('building.postalCode'),
      }),
    ),
    primaryName: Yup.string().required(t('building.nameValidation')),
    rentableBuildingArea: Yup.number().min(1, t('building.rbaMinimum')),
    street: Yup.string().required(
      t('building.requiredFieldValidation', {
        field: t('building.street'),
      }),
    ),
  };
  if (countryCode?.toLowerCase() !== 'gb') {
    (schemaFields as $TSFixMe).abbreviatedRegion = Yup.string().required(
      t('building.requiredFieldValidation', {
        field: t('building.stateRegion'),
      }),
    );
  }
  return Yup.object().shape(schemaFields);
};
export default validationSchema;
